
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oil-recycling",
      function () {
        return require("private-next-pages/oil-recycling/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/oil-recycling"])
      });
    }
  